import Controller from "./district.controller";
import template from "./district.html";

const district = {
  template,
  controller: Controller,
};

export default district;



// WEBPACK FOOTER //
// ./src/pages/district/district.component.js